(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('GitLabConfig', GitLabConfig);

    GitLabConfig.$inject = ['$http'];

    function GitLabConfig($http) {
        var resourceUrl = 'api/gitlab-config';

        var service = {
            get: get,
            save: save,
            remove: remove
        };

        return service;

        function get() {
            return $http.get(resourceUrl);
        }

        function save(config) {
            return $http.put(resourceUrl, config);
        }

        function remove() {
            return $http.delete(resourceUrl);
        }
    }
})();
